import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './constants';

// Create Supabase client - will be null if env vars not set
export const supabase = SUPABASE_URL && SUPABASE_ANON_KEY
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
  : null;

// Helper to check if Supabase is configured
export const isSupabaseConfigured = () => {
  return !!supabase;
};
